import React, { Component } from 'react';
import './FaceSvgWrapper.css';
import FaceSvg from "./FaceSvg";

class FaceSvgWrapper extends Component {

    getFaceSvgSize(videoWidth, videoHeight) {
        if (videoWidth > videoHeight) {
            console.log(`FaceSvgWrapper horizontal video detected ${videoWidth} x ${videoHeight}`)
            return { width: "40%", top: "max(175px,50%)" };
        }
        else {
            console.log(`FaceSvgWrapper vertical video detected ${videoWidth} x ${videoHeight}`)
            return { width: "70%", top: "max(175px,50%)" };
        }
    }

    render() {
        return (
            <div className="FaceSvgWrapper" style={this.getFaceSvgSize(this.props.videoWidth, this.props.videoHeight)}>
                <FaceSvg FACE_SVG_ACCEPTED={this.props.FACE_SVG_ACCEPTED} />
            </div>

        );
    }
}

export default FaceSvgWrapper;